/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { WorkflowTriggerDto } from '../../models/workflow-trigger-dto';

export interface AutomatedProcessGetAllWorkflowTriggers$Params {
}

export function automatedProcessGetAllWorkflowTriggers(http: HttpClient, rootUrl: string, params?: AutomatedProcessGetAllWorkflowTriggers$Params|null|undefined, context?: HttpContext): Observable<StrictHttpResponse<Array<WorkflowTriggerDto>>> {
  const rb = new RequestBuilder(rootUrl, automatedProcessGetAllWorkflowTriggers.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<WorkflowTriggerDto>>;
    })
  );
}

automatedProcessGetAllWorkflowTriggers.PATH = '/automated-process/workflow-trigger';